<template>
  <base-table
    title="Users"
    item-title="User"
    :headers="headers"
    :url="url"
    :item="user"
    :item-id="user.userId"
    @set-item="setItem"
  >
    <v-text-field
      v-model="user.firstname"
      :rules="[rules.required]"
      label="Fist Name"
      required
    ></v-text-field>
    <v-text-field
      v-model="user.lastname"
      :rules="[rules.required]"
      label="Last Name"
      required
    ></v-text-field>
    <v-text-field
      v-model="user.emailAddress"
      :rules="[rules.required, rules.emailAddress]"
      type="email"
      label="Email Address"
      required
    ></v-text-field>
    <v-select
      v-model="user.role"
      :rules="[rules.required]"
      :items="roles"
      item-text="name"
      item-value="value"
      label="Role"
      required
    ></v-select>
    <v-checkbox label="Enabled?" v-model="user.enabled"></v-checkbox>
  </base-table>
</template>

<script>
import ObjectType from '@/services/Objects.js'
import BaseTable from '@/components/tables/BaseTable.vue'
import Validation from '@/mixins/validation.js'
import { userRoleConstant } from '@/utils/constants'

export default {
  name: 'UserTable',
  components: {
    BaseTable
  },
  mixins: [Validation],
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'emailAddress' },
        { text: 'Role', value: 'role' },
        { text: 'Enabled', value: 'enabled' },
        { text: 'Actions', value: 'action', width: '100px' }
      ],
      user: {
        firstname: '',
        lastname: '',
        emailAddress: '',
        role: '',
        enabled: true
      },
      url: ObjectType.User,
      roles: Object.values(userRoleConstant)
    }
  },
  methods: {
    setItem(item) {
      this.user = Object.assign({}, item)
    }
  }
}
</script>

<style scoped></style>
